<div class="column">
  @switch (steps[currentStepIndex]) {
    @case ('Step1') {
      <app-walkthrough-introduction></app-walkthrough-introduction>
    }
    @case ('Step2') {
      <app-walkthrough-quickpay></app-walkthrough-quickpay>
    }
    @case ('Step3') {
      <app-walkthrough-create-invoice></app-walkthrough-create-invoice>
    }
    @case ('Step4') {
      <app-walkthrough-bulk-upload></app-walkthrough-bulk-upload>
    }
    @case ('Step5') {
      <app-walkthrough-qr-codes></app-walkthrough-qr-codes>
    }
    @case ('Step6') {
      <app-walkthrough-complete></app-walkthrough-complete>
    }
  }

  <div class="d-flex justify-content-center mb-2 mt-4">
    <button (click)="skipWalkthrough()" class="tertiary-btn mr-3">Skip</button>
    <button (click)="nextStep();" class="navy-btn">{{ nextButtonText }}
    </button>
  </div>
</div>